import React from "react";
import Icon from "../Icon/Icon";

import styles from "./ToggleSwitch.module.scss";

interface Props {
  dataQA: string;
  isDisabled?: boolean;
  isToggled: boolean;
  label: string;
  onToggle: () => void;
}

export default function ToggleSwitch({
  dataQA,
  isDisabled,
  isToggled,
  label,
  onToggle,
}: Props) {
  const inputId = `toggleSwitch-${dataQA}`;

  return (
    <div className={styles.container} data-qa={dataQA}>
      <label className={styles.label} htmlFor={inputId}>
        <span className={styles.visuallyHidden}>{label}</span>
        <input
          type="checkbox"
          className={styles.input}
          id={inputId}
          checked={isToggled}
          onChange={onToggle}
          disabled={isDisabled}
          aria-labelledby={`${inputId}-label`}
        />
        <span className={styles.slider}>
          <span className={styles.sliderToggle}>
            {isToggled && (
              <Icon type="CheckSmIcon" dataQA="toggle-check-icon" />
            )}
          </span>
        </span>
      </label>
      <span id={`${inputId}-label`} className={styles.textLabel}>
        {label}
      </span>
    </div>
  );
}
